module.exports = __webpack_public_path__ + "img/logo.f83a7525.png";